import { render, staticRenderFns } from "./OnboardingStep04.vue?vue&type=template&id=511f1c8d&"
import script from "./OnboardingStep04.vue?vue&type=script&lang=js&"
export * from "./OnboardingStep04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports